import { fetchWrapperPublic } from "helpers/fetch-wrapper";
import { API_BASE_URL } from "helpers/constants";

export async function loginUserRequest(
    data: any // would define elsewhere
): Promise<Response> {
    return await fetchWrapperPublic.publicPost(
        `${API_BASE_URL}/user/login`, data, 20000
    );
}

export async function logoutRequest(
): Promise<Response> {
    return await fetchWrapperPublic.post(
        `${API_BASE_URL}/user/logout`
    );
}

export async function changePasswordRequest(data: any): Promise<Response> {
    return await fetchWrapperPublic.patch(
        `${API_BASE_URL}/user/change-password`, data
    );
}

export async function forgotPasswordRequest(data: { email: string }): Promise<Response> {
    return await fetchWrapperPublic.publicPost(
        `${API_BASE_URL}/user/forgot-password`, data
    );
}

export async function resetPasswordRequest(data: {
    uid: string;
    token: string;
    newPassword: string;
}): Promise<Response> {
    return await fetchWrapperPublic.publicPost(
        `${API_BASE_URL}/user/reset-password`, data
    );
}

export async function refreshTokenRequest(data: any): Promise<Response> {
    return await fetchWrapperPublic.publicPost(
        `${API_BASE_URL}/v1/user/refresh-token`, data
    );
}

export async function checkDomainRequest(params: string): Promise<Response> {
    return await fetchWrapperPublic.get(
        `${API_BASE_URL}/v1/business/check-domain${params}`
    );
}

export async function signupRequest(data: any): Promise<Response> {
    return await fetchWrapperPublic.publicPost(
        `${API_BASE_URL}/v1/business/signup`, data
    );
}

export async function addressSuggestionsRequest(input: string): Promise<Response> {
    return await fetchWrapperPublic.get(
        `${API_BASE_URL}/v1/business/address-suggestions?input=${encodeURIComponent(input)}`
    );
}

export async function addressDetailsRequest(address: string, placeId: string): Promise<Response> {
    return await fetchWrapperPublic.get(
        `${API_BASE_URL}/v1/business/address-details?address=${encodeURIComponent(address)}&placeId=${encodeURIComponent(placeId)}`
    );
}
